export default __webpack_public_path__ + "static/media/favicon.211223d9.ico";